import { styled, Tabs as MuiTabs, Tab as MuiTab } from "@mui/material";

export const Tabs = styled(MuiTabs)((theme) => {
    return {
        alignItems: "center",
        // ".MuiTabs-flexContainer": {
        //     display: "flex",
        // },
    };
});

export const Tab = styled(MuiTab)(({ theme }) => {
    return {
        backgroundColor:
            theme.palette.mode === "dark"
                ? "#2E2D2C"
                : theme.palette.secondary.main,
        borderRadius: "20px",
        height: "30px",
        marginRight: "10px",
        minHeight: "fit-content",
        minWidth: "52px",
        textTransform: "none",
        "&.Mui-selected ": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.main,
        },
        //padding: ".5rem",
    };
});
